import React, { useState } from "react";
// @ts-ignore
const EditorLinkContent = ({ content, handleContentChange, index }) => {
    const [isVisible, setIsVisible] = useState(content.content.length === 0);

    return (
        <>
            <label>
                Links:
                <button onClick={() => setIsVisible(!isVisible)}>
                    {isVisible ? "👁" : "👁"}
                </button>
            </label>
            {isVisible && (
                <textarea
                    value={content.content}
                    className="text-content"
                    onChange={(e) => handleContentChange(index, { ...content, content: e.target.value })}
                />
            )}
        </>
    );
};

export default EditorLinkContent;